import React, { memo, FC } from "react";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import useLocationSelector from "./useLocationSelector";

const StyledDiv = styled("div")({
  flexBasis: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: 15,
  borderRight: "inset",
  borderLeft: "outset",
});

interface LocationProps {
  editQuote: boolean;
  submitPressed: boolean;
}

const Location: FC<LocationProps> = ({ editQuote, submitPressed }) => {
  const { handleChange, location } = useLocationSelector(
    submitPressed,
    editQuote
  );

  return (
    <StyledDiv>
      <Typography style={{ marginRight: 20 }} variant="body2">
        Enter Unit Location:{" "}
      </Typography>
      <input
        maxLength={18}
        value={location}
        onChange={handleChange}
        style={{ backgroundColor: "#eceff1" }}
        placeholder="Location"
      />
    </StyledDiv>
  );
};

export default memo(Location);
